export const customConfig = {
    absenceReport: true,
    apiUrl: 'https://prod-afa-backend.medicosonline.app/api',
    appointmentTypes: true,
    areas: true,
    asyncConsults: true,
    chatbot: true,
    company: true,
    consult: false,
    costCenters: true,
    coverages: true,
    dashboardEvolutions: true,
    diagnosisAudits: true,
    diagnosisLicense: true,
    doctorsRelated: true,
    documentTitle: 'AFA - Admin',
    entity: false,
    environment: 'prod-afa-admin',
    extendedPatientHistory: ['preoccupational', 'records', 'risk_factors', 'usual_medications', 'vaccines'],
    files: true,
    hideStatistics: {
        absenteeism: false,
        administration: true,
        diagnostics: false,
        general: false,
        interconsults: true,
        licenses: false,
        patients: false,
        professionals: false,
        recommendations: true,
        sessions: false,
        statistics: false,
        surveys: true,
        symptoms: true,
        tests: true,
        videocall: true
    },
    interconsult: false,
    language: 'OCCUPATIONAL',
    offices: true,
    orderCreation: true,
    patientHistoryRegistration: true,
    patientImport: true,
    patientListing: true,
    patientMinimumFields: true,
    patientProfile: true,
    patientRegistration: true,
    positions: true,
    professionalAllowExternal: false,
    professionalBio: true,
    professionalLocation: true,
    professionalLockedActions: true,
    professionalTimeAvailability: false,
    profile: true,
    recipes: true,
    recipesFiles: true,
    restrictedMenu: [
        'appointmentTypes',
        'offices',
        'patients',
        'professionals',
        'specialties'
    ],
    roomTimeAvailability: false,
    showPatientWaitingDuration: true,
    socketPrefix: 'prod-afa',
    socketUrl: 'https://prod-ospepri-backend.medicosonline.app',
    specialtyPin: true,
    turnOvershift: true,
    turns: true,
    turnsPresentialFlow: true,
    urlAdmin: 'https://adminsalud.afascl.coop',
    urlPatient: 'https://saludocupacional.afascl.coop',
    urlProfessional: 'https://medicos.afascl.coop',
    workplaces: true
};
